import { BaseInifiteAutocomplete } from '../base-inifite-autocomplete.component';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ControlContainer} from '@angular/forms';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-infinite-autocomplete',
  templateUrl: './infinite-autocomplete.component.html',
  styleUrls: ['./infinite-autocomplete.component.scss'],
})
export class InfiniteAutocompleteComponent extends BaseInifiteAutocomplete implements OnInit, AfterViewInit {

  constructor(
    public controlContainer: ControlContainer,
    protected authenticationService: AuthenticationService,
    ) {
    super(controlContainer, authenticationService);
    this.replaceEmptyStringWithNullYN = true; //When a (non-required) field had value and user makes it empty, the value returned by this.formControls.inputControl will  be null (instead of "").
  }


  ngOnInit() {
    if (!this.initSelection) {
      this.formControls.inputControl.setValue(null);
    } else {
      this.formControls.inputControl.setValue(this.initSelection);
    }

    this.monitorInputValueChanges();
  }


  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.initSelection) {
        if (this.openPanelIfNoValueOnInit) {
          this.inputRef.nativeElement.focus();
          this.autocompleteTrigger.openPanel();
        }
      }
    });


    this.autocompleteTrigger.panelClosingActions
      .pipe(
        takeUntil(this.unsubscribe),
      )
      .subscribe(x => {
        if (this.autocompleteTrigger.activeOption) {
          const value = this.autocompleteTrigger.activeOption.value;
          // if (this.control) {
          //   this.control.control.setValue(value, {emit: false});
          // }
          // this.autocompleteTrigger.writeValue(value);
          this.formControls.inputControl.setValue(value);
        } else {
          // No item highlighted, so we check if in the list of items there is only one, if yes, we select it
          if (this.filteredItems.length === 1) {
            this.formControls.inputControl.setValue(this.filteredItems[0]);
          }
        }
      });
  }


}
